import React from "react";
import PropTypes from "prop-types";
import Button from "../button";
import { conditionallyAddStyles } from "../../support/helpers";

const propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  submitButtonProps: PropTypes.instanceOf(Object),
  closeButtonProps: PropTypes.instanceOf(Object),
  showCloseButton: PropTypes.bool,
};

const defaultProps = {
  description: "",
  submitButtonProps: {
    label: "Confirm",
  },
  closeButtonProps: {
    label: "Cancel",
    outline: true,
  },
  showCloseButton: true,
};

const ConfirmationDialog = ({
  title,
  description,
  onSubmit,
  onClose,
  submitButtonProps,
  closeButtonProps,
  showCloseButton,
}) => {
  const defaultButtonGridClasses = ["grid", "gap-4", "p-4"];

  conditionallyAddStyles(
    showCloseButton,
    defaultButtonGridClasses,
    "grid-cols-2",
    "grid-cols-1"
  );

  return (
    <div className="bg-white md:w-3/12 shadow">
      <div className="flex flex-grow flex-col">
        <div className="text-xl font-bold border-b p-4">{title}</div>
        <div className="p-4">{description}</div>
      </div>
      <div className={defaultButtonGridClasses.join(" ")}>
        {showCloseButton && <Button {...closeButtonProps} onClick={onClose} />}
        <Button {...submitButtonProps} onClick={onSubmit} />
      </div>
    </div>
  );
};

ConfirmationDialog.propTypes = propTypes;

ConfirmationDialog.defaultProps = defaultProps;

export default ConfirmationDialog;
